import React, { useState } from 'react';
import { Linkedin, Facebook, Instagram, Twitter, Share2 } from 'lucide-react';

// TikTok Icon SVG Component
const TikTokIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const SocialSidebar = () => {
  const [isHovered, setIsHovered] = useState(false);

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: 'https://www.linkedin.com/company/oli-gardens/',
      color: 'hover:text-blue-600',
    },
    {
      name: 'Facebook',
      icon: Facebook,
      url: 'https://www.facebook.com/p/OLI-Gardens-100076180795761/',
      color: 'hover:text-blue-500',
    },
    {
      name: 'Instagram',
      icon: Instagram,
      url: 'https://www.instagram.com/oli_gardens25/',
      color: 'hover:text-pink-500',
    },
    {
      name: 'X',
      icon: Twitter,
      url: 'https://x.com/gardensoli7022',
      color: 'hover:text-sky-400',
    },
    {
      name: 'TikTok',
      icon: TikTokIcon,
      url: 'https://www.tiktok.com/@oli_gardens',
      color: 'hover:text-black',
    },
  ];

  return (
    <div className="fixed right-0 bottom-0 z-40 hidden lg:block mb-4 mr-4">
      <div
        className="flex flex-col items-center rounded-tl-2xl backdrop-blur-md bg-green-600/10 border border-white/20 shadow-lg transition-all duration-300 ease-in-out"
        style={{
          padding: '0.75rem',
          gap: isHovered ? '1rem' : '0',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Collapsed state - Single socials icon */}
        {!isHovered && (
          <div className="flex items-center justify-center w-9 h-9 rounded-full bg-black/20 backdrop-blur-sm border border-white/30 transition-all duration-300">
            <Share2 className="w-5 h-5 text-white" />
          </div>
        )}

        {/* Expanded state - All social icons */}
        {isHovered && (
          <div className="flex flex-col items-center gap-4 transition-all duration-300 ease-in-out">
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`group relative flex items-center justify-center w-9 h-9 rounded-full bg-green-800/20 backdrop-blur-sm border border-white/30 transition-all duration-300 ${social.color} hover:scale-110 hover:bg-white/30 hover:shadow-lg hover:-translate-x-2`}
                  aria-label={social.name}
                  style={{
                    animationDelay: `${index * 30}ms`,
                  }}
                >
                  <Icon className="w-5 h-5 text-white transition-all duration-300 group-hover:scale-125" />
                  <span className="absolute right-full mr-3 px-3 py-1.5 text-sm font-medium text-white bg-white/20 backdrop-blur-md rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none border border-white/30">
                    {social.name}
                  </span>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SocialSidebar;

